<template>
  <article>
    <header class="staff-title">
      <h2 class="staff-name" v-if="userName">{{userName}}，{{getTimeTitle()}}</h2>
      <h2 class="staff-name" v-else>{{getTimeTitle()}}</h2>
    </header>
    <group>
      <cell class="mywork-info-title">
        <span slot="icon" class="icon icon-reception"></span>
        <p slot="after-title" class="title">今日接待</p>
      </cell>
      <cell class="mywork-info">
        <flexbox slot="after-title">
          <flexbox-item v-if="appointmentAsset()" @click.native="navigate('/salemanage/staff/reservation')">
            <div class="mywork-detail border-r">
              <h2>{{pageData.book_today_customer_and_clue_num}}</h2>
              <p>预约到店</p>
            </div>
          </flexbox-item>

          <flexbox-item v-if="passengerFlow()" @click.native="navigate('/salemanage/staff/visitors')">
            <div class="mywork-detail">
              <h2>{{pageData.today_store_visit_num}}</h2>
              <p>到店客流</p>
            </div>
          </flexbox-item>

        </flexbox>
      </cell>
    </group>
    <group v-if="todayCustomerTask() || allCustomerTask()|| allCustomer() ">
      <cell class="mywork-info-title">
        <span slot="icon" class="icon icon-client"></span>
        <p slot="after-title" class="title">客户</p>
      </cell>
      <cell class="mywork-info">
        <flexbox slot="after-title">
          <flexbox-item v-if="todayCustomerTask()" @click.native="navigate('/salemanage/staff/todaycustomertask')">
            <div class="mywork-detail border-r">
              <h2>{{pageData.today_customer_task_num}}</h2>
              <p>今日任务</p>
            </div>
          </flexbox-item>
          <flexbox-item v-if="allCustomerTask()" @click.native="navigate('/salemanage/staff/allcustomertask')">
            <div class="mywork-detail border-r">
              <h2>{{pageData.customer_task_num}}</h2>
              <p>全部任务</p>
            </div>
          </flexbox-item>
          <flexbox-item v-if="allCustomer()" @click.native="navigate('/salemanage/staff/allcustomer')">
            <div class="mywork-detail">
              <h2>{{pageData.customer_num}}</h2>
              <p>全部客户</p>
            </div>
          </flexbox-item>
        </flexbox>
      </cell>
    </group>
    <group v-if="aboutClue()">
      <cell class="mywork-info-title">
        <span slot="icon" class="icon icon-clue"></span>
        <p slot="after-title" class="title">线索</p>
      </cell>
      <cell class="mywork-info">
        <flexbox slot="after-title">
          <flexbox-item @click.native="navigate('/salemanage/staff/todaycluetask')">
            <div class="mywork-detail border-r">
              <h2>{{pageData.today_pending_follow_up_clue_num}}</h2>
              <p>今日任务</p>
            </div>
          </flexbox-item>
          <flexbox-item @click.native="navigate('/salemanage/staff/allcluetask')">
            <div class="mywork-detail border-r">
              <h2>{{pageData.pending_follow_up_clue_num}}</h2>
              <p>全部任务</p>
            </div>
          </flexbox-item>
          <flexbox-item @click.native="navigate('/salemanage/staff/allclue')">
            <div class="mywork-detail">
              <h2>{{pageData.clue_num}}</h2>
              <p>全部线索</p>
            </div>
          </flexbox-item>
        </flexbox>
      </cell>
    </group>
  </article>
</template>
<script>
import {
  Flexbox,
  FlexboxItem,
  Cell,
  Group
} from '@lx-frontend/cvux'
import authApi from '../../../common/auth'

export default {
  components: {
    Flexbox,
    FlexboxItem,
    Cell,
    Group
  },
  data () {
    return {
      authArr: [],
      // 查看个人客户+ 跟进客户
      pageAuth1: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_follow_up],
      // 查看个人线索 + 跟进客户
      pageAuth2: [authApi.saleManage.sale_clue_view_self, authApi.saleManage.sale_clue_follow_self],
      // 查看全部线索 + 跟进全部线索
      pageAuth3: [authApi.saleManage.sale_clue_view_all, authApi.saleManage.sale_clue_follow_all],
      // 今日预约到店 线索
      appointmentClueAuth: [authApi.saleManage.sale_clue_view_self, authApi.saleManage.sale_clue_view_all],
      // 今日预约到店 客户
      appointmentCustomerAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      // 今日到店客流
      passengerFlowAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      // 今日客户任务 任务 / 客户
      todayCustomerTaskAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      // 全部客户任务
      allCustomerTaskAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      // 全部客户
      allCustomerAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      // 今日线索任务、全部线索任务，全部线索
      aboutClueAuth: [authApi.saleManage.sale_clue_view_self, authApi.saleManage.sale_clue_view_all],
      clue: false,
      userName: '',
      pageData: {}
    }
  },
  created () {
    this.$store.state.promiseAuth.then(auth => {
      this.authArr = auth.authList
      let pageAuth1 = authApi.haveEveryAuth(this.pageAuth1, this.authArr)
      let pageAuth2 = authApi.haveEveryAuth(this.pageAuth2, this.authArr)
      let pageAuth3 = authApi.haveEveryAuth(this.pageAuth3, this.authArr)
      if (pageAuth1 || pageAuth2 || pageAuth3) {
        this.userName = auth.userName
        this.$rest.saleManage.staffWorkStatistics().then(res => {
          if (res.code === 0) {
            this.pageData = res.data
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    getTimeTitle () {
      let hours = new Date().getHours()
      let str = ''
      if (hours < 12) {
        str = '上午好'
      } else if (hours >= 12 && hours < 18) {
        str = '下午好'
      } else if (hours >= 18) {
        str = '晚上好'
      }
      return str
    },
    navigate (url) {
      this.$router.push(url)
    },
    appointmentAsset () {
      let allAuth = this.authArr
      let clue = authApi.haveSomeAuth(this.appointmentClueAuth, allAuth)
      let cus = authApi.haveSomeAuth(this.appointmentCustomerAuth, allAuth)
      return clue || cus
    },
    passengerFlow () {
      return authApi.haveSomeAuth(this.passengerFlowAuth, this.authArr)
    },
    todayCustomerTask () {
      return authApi.haveSomeAuth(this.todayCustomerTaskAuth, this.authArr)
    },
    allCustomerTask () {
      return authApi.haveSomeAuth(this.allCustomerTaskAuth, this.authArr)
    },
    allCustomer () {
      return authApi.haveSomeAuth(this.allCustomerAuth, this.authArr)
    },
    aboutClue () {
      return authApi.haveSomeAuth(this.aboutClueAuth, this.authArr)
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
